import { useEffect } from 'react';

/**
 * Hook to trigger a callback when locale changes.
 * Use this for components that need to refetch localized data from the backend.
 *
 * The 'localeChanged' event is dispatched by header components AFTER:
 * 1. localStorage is updated
 * 2. API call to update user locale completes (if logged in)
 * 3. i18n.changeLanguage() completes
 *
 * This ensures axios interceptor will send correct Accept-Language header.
 *
 * @param callback - Function to call when locale changes
 * @param deps - Optional additional dependencies
 */
export const useLocaleChange = (callback: () => void, deps: React.DependencyList = []) => {
  useEffect(() => {
    const handleLocaleChanged = () => {
      callback();
    };

    window.addEventListener('localeChanged', handleLocaleChanged);
    return () => {
      window.removeEventListener('localeChanged', handleLocaleChanged);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback, ...deps]);
};

export default useLocaleChange;
